// Canonical notification categories — single source of truth.
// Used by NotificationSettings, NotificationCenter, and FCM foreground routing.
// Ordered by criticality (consultation first, system last).

export const CANONICAL_CATEGORIES = [
  { key: 'consultation',    label: 'Consultations',      icon: 'VideoCall',            pushDefault: true,  pushLocked: true,  bypassQuietHours: true,  channels: ['in_app', 'push', 'email', 'sms'] },
  { key: 'slot_reminder',   label: 'Slot Reminders',     icon: 'AccessAlarm',          pushDefault: true,  pushLocked: false, bypassQuietHours: true,  channels: ['in_app', 'push', 'email'] },
  { key: 'daily_panchanga', label: 'Daily Panchanga',    icon: 'WbSunny',              pushDefault: true,  pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push'] },
  { key: 'wallet',          label: 'Wallet & Billing',   icon: 'AccountBalanceWallet', pushDefault: true,  pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push', 'email', 'sms'] },
  { key: 'queue',           label: 'Queue Updates',      icon: 'Queue',                pushDefault: false, pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push'] },
  { key: 'earnings',        label: 'Earnings & Payouts', icon: 'TrendingUp',           pushDefault: true,  pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push', 'email'] },
  { key: 'reviews',         label: 'Reviews',            icon: 'Star',                 pushDefault: false, pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push'] },
  { key: 'promotions',      label: 'Promotions',         icon: 'LocalOffer',           pushDefault: true,  pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push', 'email'] },
  { key: 'system',          label: 'System',             icon: 'Settings',             pushDefault: true,  pushLocked: false, bypassQuietHours: false, channels: ['in_app', 'push'] },
];

export const CATEGORY_DEEP_LINK_MAP = {
  consultation:    '/consultations',
  slot_reminder:   '/bookings',
  daily_panchanga: '/panchanga',
  wallet:          '/notifications',
  queue:           '/notifications',
  earnings:        '/notifications',
  reviews:         '/notifications',
  promotions:      '/',
  system:          '/notifications',
};
